import React from 'react'

const Contact = () => {
  return <h2>This is contact Page</h2>
}

export default Contact
